import { useState, useEffect } from 'react'
import { ITransactionSetWithSubtype, IConfigurableBuilderTest } from 'types/graphqlTypes'
import { useSerializedJsonMutation } from '../graphql/SerializedJsonMutation'
import { formatForCodeEditor } from '../utils/formatting'

interface IUseSerializedJsonLoaderArgs {
  displayUserFeedback: (message: string, level: 'error' | 'info') => void
  transactionSetWithSubtype: ITransactionSetWithSubtype
  options: IConfigurableBuilderTest
}

export const useSerializedJsonLoader = ({
  displayUserFeedback,
  options,
  transactionSetWithSubtype,
}: IUseSerializedJsonLoaderArgs) => {
  const [isLoadingSerializedJson, setIsLoadingSerializedJson] = useState<boolean>(true)
  const [serializedJsonData, setSerializedJsonData] = useState<string>()

  const [getSerializedJsonMutation] = useSerializedJsonMutation()

  const getSerializedJson = async ({
    transactionSetWithSubtype,
  }: {
    transactionSetWithSubtype: ITransactionSetWithSubtype
  }) => {
    const { accountingInvoiceId, changedField, changedShipperStopSequence, shipmentId } = options
    try {
      const response = await getSerializedJsonMutation({
        variables: {
          input: {
            ...transactionSetWithSubtype,
            accountingInvoiceId,
            changedField,
            changedShipperStopSequence,
            shipmentId,
          },
        },
      })
      const errors = response.data?.getSerializedJson?.errors || []
      if (errors.length === 0) {
        const serializedJson = response.data?.getSerializedJson?.serializedJson || []
        const formattedJson = formatForCodeEditor(serializedJson)
        setSerializedJsonData(formattedJson)
        setIsLoadingSerializedJson(false)
      } else {
        displayUserFeedback(errors[0].message, 'error')
      }
    } catch (e) {
      displayUserFeedback(e.message, 'error')
    }
  }

  // TODO: Need to introduce ediMessageSubtype to bring back support for scheduled tracking 214s.
  useEffect(() => {
    if (options) {
      setIsLoadingSerializedJson(true)
      getSerializedJson({
        transactionSetWithSubtype,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options])
  return {
    isLoadingSerializedJson,
    serializedJsonData,
  }
}
